module.exports = __webpack_public_path__ + "fonts/ProximaNovaCondensedW05-Lt.26fdabbe.ttf";